type TranslateFn = (key: string, options?: { count?: number }) => string;

/**
 * Render an ISO timestamp as a localized relative time ("3m ago", "2h ago",
 * "5d ago") falling back to a locale date string for anything older than a week.
 * Mirrors the buckets the Atlas status history has always used.
 */
export function formatRelativeTime(dateString: string, t: TranslateFn): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return t('time.justNow');
  if (diffMins < 60) return t('time.minutesAgo', { count: diffMins });
  if (diffHours < 24) return t('time.hoursAgo', { count: diffHours });
  if (diffDays < 7) return t('time.daysAgo', { count: diffDays });

  return date.toLocaleDateString();
}
